export const RM_ROUTES = {
  DASHBOARD: "/RMDashboard",
};
